module.exports = __webpack_public_path__ + "static/media/learning3.1d6ec9ae.png";